module.exports = __webpack_public_path__ + "static/media/ENET.40874348.png";